// extracted by mini-css-extract-plugin
module.exports = {"WrapperError":"ErrorUserLk_WrapperError__32QvD","Text":"ErrorUserLk_Text__RTFLl","Desr":"ErrorUserLk_Desr__jmAkM"};